module.exports = "https://web-assets.ifttt.com/packs/media/header/search-8fc767d0.svg";